import React from "react";
import TopMostPortal from "../Portals";

export const PreviewImage: React.FC<{
	imageUrl: string;
	cls: string;
}> = ({ imageUrl, cls }) => {
	const [previewImage, setPreviewImage] = React.useState<string | null>(null);
	return (
		<>
			<img
				src={imageUrl}
				alt="Clickable"
				className={`cursor-pointer hover:opacity-80 transition-opacity duration-200 ${cls}`}
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
					setPreviewImage(imageUrl);
				}}
				// style={{ maxWidth: "100%", height: "auto" }}
			/>
			{previewImage && (
				<TopMostPortal>
					<div className="mt-4 relative bg-white p-4 rounded shadow-lg">
						<div
							className="absolute top-0 right-0 bg-gray-500 text-white p-2 cursor-pointer"
							onClick={(e) => {
								e.stopPropagation();
								e.preventDefault();
								setPreviewImage(null);
							}}
							style={{ zIndex: 1000 }}
						>
							X
						</div>
						<img src={previewImage} alt="Preview" width={512} height={512} className="w-128 h-128 object-cover" />
					</div>
				</TopMostPortal>
			)}
		</>
	);
};
